import { render, staticRenderFns } from "./selectMsgList.vue?vue&type=template&id=780cfa3e&scoped=true"
import script from "./selectMsgList.vue?vue&type=script&lang=js"
export * from "./selectMsgList.vue?vue&type=script&lang=js"
import style0 from "./selectMsgList.vue?vue&type=style&index=0&id=780cfa3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780cfa3e",
  null
  
)

export default component.exports